import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { media } from 'src/styles/styled-components'
import deviceInfoProvider from 'src/utils/deviceInfoProvider'

// ArComponents
import ArBaseImage from 'src/components/ArBaseImage/ArBaseImage'

const StyledWrapper = styled.div`
  ${ ({ mobileImageWrapperStyles }) => mobileImageWrapperStyles }
  ${ media.tablet`${ ({ tabletImageWrapperStyles }) => tabletImageWrapperStyles }` }
  ${ media.desktop`${ ({ desktopImageWrapperStyles }) =>
    desktopImageWrapperStyles }` }
`

const StyledImage = styled(ArBaseImage)`
  ${ ({ mobileImageStyles }) => mobileImageStyles }
  ${ media.tablet`${ ({ tabletImageStyles }) => tabletImageStyles }` }
  ${ media.desktop`${ ({ desktopImageStyles }) => desktopImageStyles }` }
`

const StyledVideoWrapper = styled.div`
  ${ ({ mobileImageStyles }) => mobileImageStyles }
  ${ media.tablet`${ ({ tabletImageStyles }) => tabletImageStyles }` }
  ${ media.desktop`
    ${ ({ desktopImageStyles }) => desktopImageStyles }` }
`

const TypeImageShape = PropTypes.shape({
  alt: PropTypes.string,
  copyright: PropTypes.string,
  url: PropTypes.string,
})

class ArHeroImageWrapper extends React.Component {
  static propTypes = {
    imageDesktop: TypeImageShape,
    imageTablet: TypeImageShape,
    imageMobile: TypeImageShape,
    image: TypeImageShape,
    mobileImageWrapperStyles: PropTypes.any,
    tabletImageWrapperStyles: PropTypes.any,
    desktopImageWrapperStyles: PropTypes.any,
    mobileImageStyles: PropTypes.any,
    tabletImageStyles: PropTypes.any,
    desktopImageStyles: PropTypes.any,
  };
  get deviceMediaFile () {
    if (
      this.props.device.isDesktop &&
      (this.props.imageDesktop || this.props.videoDesktop)
    ) {
      return this.props.imageDesktop || this.props.videoDesktop
    } else if (
      this.props.device.isTablet &&
      (this.props.imageTablet || this.props.videoTablet)
    ) {
      return this.props.imageTablet || this.props.videoTablet
    } else if (
      this.props.device.isMobile &&
      (this.props.imageMobile || this.props.videoMobile)
    ) {
      return this.props.imageMobile || this.props.videoMobile
    } else return this.props.image || this.props.video
  }

  render () {
    const mediaFile = this.deviceMediaFile

    return mediaFile ? (
      <StyledWrapper {...this.props}>
        {mediaFile.type && mediaFile.type.includes('video') ? (
          <StyledVideoWrapper
            dangerouslySetInnerHTML={{
            // React doesn't support `muted` attribute :( so best option is to use dangerouslySetInnerHTML.
              __html: `<video src=${ mediaFile.src } autoplay muted playsinline loop></video>`,
            }}/>
        ) : (
          <StyledImage
            {...this.props}
            src={mediaFile.url}
            alt={mediaFile.alt}
            scFit={'contain'}
          />
        )}
      </StyledWrapper>
    ) : null
  }
}

export default deviceInfoProvider(ArHeroImageWrapper)
